import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Product2, RequestedProduct } from 'situview-webapi-client';

@Component({
  selector: 'situ-reel-product-picker-dialog',
  templateUrl: './situ-reel-product-picker-dialog.component.html',
  styleUrls: ['./situ-reel-product-picker-dialog.component.scss']
})
export class SituReelProductPickerDialogComponent {
  constructor(public dialogRef: MatDialogRef<SituReelProductPickerDialogComponent, Product2>) {}

  onPicked(products: (Product2 | RequestedProduct)[]): void {
    const first = products?.[0];
    if (!first) return;
    // The reel-edit dialog validates that previewArtifactId is present and
    // surfaces a snackbar if not, so we don't filter RequestedProduct here.
    this.dialogRef.close(first as Product2);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
